import styled from 'styled-components';
import { breakPoints } from '~/styles/break-points';

export const ConfigurationSectionStyle = styled.section`
	display: flex;
	flex-direction: column;
	gap: 4px;
	flex-grow: 1;

	.section-container {
		display: grid;
		column-gap: 64px;
		row-gap: 8px;
		${breakPoints({
			'768': `grid-template-columns: repeat(2, minmax(0, 1fr))`,
		})};
	}

	.title {
		display: flex;
		align-items: center;
	}

	.alignRight {
		text-align: unset;
		${breakPoints({
			'375': `
				text-align: right;
			`,
		})}
	}

	.children-container {
		display: flex;
		flex-direction: column;
		gap: 32px;
	}
`;

export const TopSectionStyle = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	width: 100%;
	max-width: 1248px;
`;

export const PriceSectionStyle = styled.section`
	display: flex;
	flex-direction: column;
	gap: 8px;

	.price-grid {
		display: grid;
		grid-template-columns: 1fr;
		column-gap: 4rem;
		row-gap: 0.5rem;
		align-items: baseline;

		p:first-of-type {
			word-break: break-word;
		}

		${breakPoints({
			'375': `
				grid-template-columns: repeat(2,minmax(0,auto));
			`,
		})}
	}

	.alignRight {
		text-align: unset;
		${breakPoints({
			'375': `
				text-align: right;
			`,
		})}
	}
`;
